import PublicEntityCard from '@/components/public/PublicEntityCard/PublicEntityCard.vue';

export default {
  name: 'PublicTournamentCard',
  components: {
    PublicEntityCard,
  },
  props: {
    placeName: { type: String, default: '' },
    placeUnderBadges: { type: Boolean, default: false },
    to: {
      type: [Object, String],
      default: null,
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: '',
    },
    badge: {
      type: String,
      default: '',
    },
    badgeClass: {
      type: [String, Array, Object],
      default: '',
    },
    badgeTooltip: {
      type: String,
      default: '',
    },
    timeBadge: {
      type: String,
      default: '',
    },
    status: {
      type: Object,
      default: null,
    },
    systemLabel: {
      type: String,
      default: '',
    },
    systemType: {
      type: String,
      default: '',
    },
    systemClass: {
      type: String,
      default: '',
    },
    backgroundImage: {
      type: String,
      default: '',
    },
    imageMode: {
      type: Boolean,
      default: false,
    },
    scrollCard: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    cardClass() {
      return {
        'public-tournament-card--image': this.imageMode,
        'public-tournament-card--scroll': this.scrollCard,
        'public-tournament-card--clickable': Boolean(this.to),
        [`public-tournament-card--${this.systemType}`]: Boolean(this.systemType),
      };
    },
  },
};
